module.exports = __webpack_public_path__ + "img/brick-house.b4827870.jpg";